import React, { useRef, useState } from "react";
import { StyleSheet, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../toolkit/store";
import { useNavigation } from "@react-navigation/native";
import { removeOrder } from "../toolkit/features/orderNotifications";
import OrderNotificationItem from "./orderNotificationItem";
import CustomFlatList from "./flatlist";
import { SCREEN_WIDTH } from "../libs/utils/constants";
import variables from "../assets/variables";
import useMaster from "../libs/hooks/useMaster";

const OrderNotificationBar = () => {
  const navigation = useNavigation<any>();
  const dispatch = useDispatch<any>();
  const [current, setCurrent] = useState(0);

  const { orders } = useSelector(
    (state: RootState) => state.orderNotifications
  );

  const onViewableItemsChanged = useRef(({ viewableItems, changed }) => {
    const visibleItemIndex = viewableItems[0].index;
    setCurrent(visibleItemIndex);
  });

  if (!orders.length) {
    return null;
  }

  const item = orders[1];

  const openDetail = (id: string) => {
    navigation.navigate("OrderDetailRoot", {
      ids: id,
    });
  };

  const remove = (id: string) => {
    dispatch(removeOrder({ id }));
  };

  const renderItem = ({ item }) => {
    return (
      <OrderNotificationItem
        item={item}
        openDetail={openDetail}
        remove={remove}
      />
    );
  };

  return (
    <View style={styles.root}>
      <CustomFlatList
        data={orders}
        renderItem={renderItem}
        horizontal
        pagingEnabled
        decelerationRate="fast"
        snapToInterval={SCREEN_WIDTH - 30}
        onViewableItemsChanged={onViewableItemsChanged.current}
      />
      {orders?.length > 1 && (
        <View style={styles.indicatorContainer}>
          {orders.map((it, index) => {
            return (
              <View
                key={it._id}
                style={[
                  styles.indicator,
                  index === current && styles.selectedIndicator,
                ]}
              />
            );
          })}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    position: "absolute",
    left: 15,
    right: 15,
    bottom: 60,
    height: 100,
    paddingTop: 5,
    paddingBottom: 5,
  },
  indicatorContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  indicator: {
    height: 6,
    width: 6,
    borderRadius: 6,
    marginRight: 2,
    backgroundColor: variables.$disabledButton,
    marginTop: 5,
  },
  selectedIndicator: {
    height: 8,
    width: 8,
    borderRadius: 8,
    backgroundColor: variables.$brandColor,
  },
});

export default OrderNotificationBar;
